import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ProjectHolidayList = Loadable(lazy(() => import('./ProjectHolidayList')));

const ProjectHolidayRoutes = [
  {
    path: '/projectholiday/list',
    element: <ProjectHolidayList />,
    auth: authRoles.admin,
  },
];

export default ProjectHolidayRoutes;
